import React, { Component } from 'react';
import { Link } from 'gatsby'
import { connectInfiniteHits } from 'react-instantsearch-dom';

class InfiniteCustomHits extends Component {
  
  onSentinelIntersection = entries => {
    const { hasMore, refineNext } = this.props;
    entries.forEach(entry => {
      if (entry.isIntersecting && hasMore) {
        refineNext();
      }
    });
  };

  componentDidMount() {
    this.observer = new IntersectionObserver(this.onSentinelIntersection);
    this.observer.observe(this.sentinel);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  render() {
    const items = this.props.hits;
    const shuffledItems = shuffle([...items]);

    if (this.props.shuffle) {
      //console.log("shuffled")
      return (
        <section id="one" className="tiles">
        {shuffledItems &&
          shuffledItems.map((item, index) => (
              <article key={index} style={{ backgroundImage: `url(${item.cover})` }} className="blend-in">
                <Link
                  aria-label="Link to User Profile"
                  to={
                    "/profile/" + 
                    item.userId
                  }
                  className="link primary"
                  >
                  <header className="major cards-margin">
                    <h3>{item.prename} {item.surname}</h3>
                    <p className="subtitle">{item.jobtitle ? (<>{item.jobtitle} | </>) : (<></>)}{item.company}</p>
                  </header>
                </Link>
              </article>
          ))}
          <span
            className="ais-InfiniteHits-sentinel"
            ref={c => (this.sentinel = c)}
          />
        </section>
      )
    } else {
      //console.log("normal")
      return (
        <section id="one" className="tiles">
        {items &&
          items.map((item, index) => (
              <article key={index} style={{ backgroundImage: `url(${item.cover})` }} className="blend-in">
                <Link
                  aria-label="Link to User Profile"
                  to={
                    "/profile/" + 
                    item.userId
                  }
                  className="link primary"
                  >
                  <header className="major cards-margin">
                    <h3>{item.prename} {item.surname}</h3>
                    <p className="subtitle">{item.jobtitle ? (<>{item.jobtitle} | </>) : (<></>)}{item.company}</p>
                  </header>
                </Link>
              </article>
          ))}
          <span
            className="ais-InfiniteHits-sentinel"
            ref={c => (this.sentinel = c)}
          />
        </section>
      )
    }
  }
}

export default connectInfiniteHits(InfiniteCustomHits);

 function shuffle(sourceArray) {
  for (var i = 0; i < sourceArray.length - 1; i++) {
      var j = i + Math.floor(Math.random() * (sourceArray.length - i));

      var temp = sourceArray[j];
      sourceArray[j] = sourceArray[i];
      sourceArray[i] = temp;
  }
  return sourceArray;
}